export enum ProjectStatus {
    ACTIVE = 'active',
    DONE = 'done',
    ARCHIVED = 'archived',
}
